import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["result"]
  declare readonly resultTarget: HTMLElement

  showScan(event: CustomEvent) {
    const barcode = event.detail?.barcode
    if (barcode) {
      this.resultTarget.textContent = barcode
    } else {
      this.resultTarget.textContent = "No barcode received"
    }
    this.resultTarget.classList.remove("hidden")
  }
}
